import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=35fc7e28&scoped=true&"
import script from "./banner.vue?vue&type=script&lang=js&"
export * from "./banner.vue?vue&type=script&lang=js&"
import style0 from "./banner.vue?vue&type=style&index=0&id=35fc7e28&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fc7e28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/fintopia-web7chz7/fintopia-web-ci/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35fc7e28')) {
      api.createRecord('35fc7e28', component.options)
    } else {
      api.reload('35fc7e28', component.options)
    }
    module.hot.accept("./banner.vue?vue&type=template&id=35fc7e28&scoped=true&", function () {
      api.rerender('35fc7e28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/lingyue-tech/index/component/banner/banner.vue"
export default component.exports